export default __webpack_public_path__ + "static/media/statement-activity.fa8659ab.svg";